// El contador de pantallas. Una llamada por cambio de pantalla, y ninguna que se note.
//
// POR QUE EXISTE. La Academia tiene 49 pantallas y ninguna forma de saber cuales se abren.
// Despues del piloto hay que decidir que se queda y que sobra, y eso se decide con un numero o
// se decide con una impresion. Lo que no se registre el primer dia no se puede mirar el treinta.
//
// LO QUE SE MANDA ES LA DIRECCION Y NADA MAS. Ni cuanto rato, ni de donde venia, ni el nombre
// de nadie: el servidor la normaliza -`/leccion/7f3a...` pasa a ser `/leccion/:id`- y suma uno.
//
// NO USA `api` NI AXIOS, y es a proposito. `sendBeacon` esta hecho justo para esto: el navegador
// se encarga de mandarlo aunque el alumno cambie de pantalla o cierre la pestaña en ese mismo
// instante, y no bloquea nada. Si no existe -Safari viejo-, se cae a `fetch` con `keepalive`.
//
// Y DESDE EL 10 DE OCTUBRE DE 2026, DOS DATOS GRUESOS DEL APARATO (roadmap movil): si la
// pantalla es tactil y en que tramo cae el ancho de la ventana -estrecho, medio o ancho, con los
// cortes de Tailwind-. Ni el modelo, ni el navegador, ni el ancho exacto: el servidor suma uno
// en una de seis casillas del recuento, y la casilla no lleva a nadie dentro. Sin esto no se
// sabe desde donde se entra hoy, ni si lo que se cambie para el movil mueve algo.
//
// Y NUNCA SE ESPERA NI SE MIRA LA RESPUESTA. Medir no puede estorbar a lo medido: si el
// contador falla, el alumno no se entera y la leccion se abre igual.
import { api } from "./client";

const RUTA = (api?.defaults?.baseURL || "") + "/uso";

/** `{tactil, ancho}` de este aparato, o `{}` si el navegador no contesta. Se pregunta cada vez:
 *  girar el movil o estrechar la ventana cambia la respuesta, y es barato. */
export const comoEsElAparato = (ventana = typeof window === "undefined" ? null : window) => {
  try {
    const w = Number(ventana?.innerWidth) || 0;
    if (!w || !ventana.matchMedia) return {};
    return {
      tactil: !!ventana.matchMedia("(pointer: coarse)").matches,
      ancho: w < 640 ? "estrecho" : w < 1024 ? "medio" : "ancho",
    };
  } catch {
    return {};
  }
};

export const apuntaPantalla = (pantalla) => {
  if (!pantalla) return;
  const cuerpo = JSON.stringify({ pantalla, ...comoEsElAparato() });
  try {
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      // `type: application/json` para que el backend lo lea como el resto; sin esto llega
      // como texto plano y FastAPI contesta 422 a cada cambio de pantalla.
      navigator.sendBeacon(RUTA, new Blob([cuerpo], { type: "application/json" }));
      return;
    }
  } catch (e) {
    // Da igual por que fallo: se intenta por la otra via.
  }
  try {
    fetch(RUTA, {
      method: "POST",
      body: cuerpo,
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // Y si tampoco, no pasa nada: se pierde una visita, no una leccion.
  }
};
